import React from 'react';
import SvgIcon from './SvgIcon';

const Flood = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M23.5 18s-3 3-6 3c-4.8 0-6.2-3-11-3-3 0-6 3-6 3M23.5 14.5s-3 3.5-6 3.5c-4.8 0-6.2-3-11-3-3 0-6 2.5-6 2.5M12.476 13.858A4.5 4.5 0 008.01 6.609a.768.768 0 01-.741-1.26A6.981 6.981 0 0112.499 3a8 8 0 018 8 3.327 3.327 0 003 3.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Flood.displayName = 'FloodIcon';

export default Flood;
